import { MaterialCommunityIcons, MaterialIcons } from '@expo/vector-icons';
import { Tabs } from 'expo-router';
import React from 'react';
import 'react-native-get-random-values';

const TabsLayout = () => {
  return (
    <Tabs
      screenOptions={{
        tabBarActiveTintColor: '#FFD60A',
        tabBarInactiveTintColor: '#A3CEF1',
        tabBarShowLabel: true,
        headerShown: false,
        tabBarStyle: {
          backgroundColor: '#001D3D',
          borderTopWidth: 0,
          elevation: 0,
        },
      }}>
      <Tabs.Screen
        name="Feed"
        options={{
          title: 'Feed',
          headerShown: false,
          tabBarIcon: ({ color, focused }) =>
            focused ? (
              <MaterialIcons name="feed" size={24} color={color} />
            ) : (
              <MaterialIcons name="feed" size={24} color={color} />
            ),
        }}
      />

      <Tabs.Screen
        name="Subs"
        options={{
          title: 'Subscriptions',
          headerShown: false,
          tabBarIcon: ({ color, focused }) =>
            focused ? (
              <MaterialIcons name="bookmark" size={24} color={color} />
            ) : (
              <MaterialIcons name="bookmark" size={24} color={color} />
            ),
        }}
      />

      <Tabs.Screen
        name="Places"
        options={{
          title: 'Map',
          headerShown: false,
          tabBarIcon: ({ color, focused }) =>
            focused ? (
              <MaterialCommunityIcons name="map" size={24} color={color} />
            ) : (
              <MaterialCommunityIcons name="map-outline" size={24} color={color} />
            ),
        }}
      />

      <Tabs.Screen
        name="Buskers"
        options={{
          title: 'Discovery',
          headerShown: false,
          tabBarIcon: ({ color, focused }) =>
            focused ? (
              <MaterialIcons name="person-search" size={24} color={color} />
            ) : (
              <MaterialIcons name="person-search" size={24} color={color} />
            ),
        }}
      />

      <Tabs.Screen
        name="Profile"
        options={{
          title: 'Profile',
          headerShown: false,
          tabBarIcon: ({ color, focused }) =>
            focused ? (
              <MaterialIcons name="person" size={24} color={color} />
            ) : (
              <MaterialIcons name="person-outline" size={24} color={color} />
            ),
        }}
      />
    </Tabs>
  );
};

export default TabsLayout;
